export const REQUIRED = "REQUIRED";
export const NOT_VALID = "NOT_VALID";
export const MIN_VALUE = "MIN_VALUE";
export const MIN_LENGTH = "MIN_LENGTH";
export const USER_INACTIVE = "USER_INACTIVE";
export const USER_ALREADY_EXISTS = "USER_ALREADY_EXISTS";
export const CURRENT_PASSWORD_NOT_MATCH = "CURRENT_PASSWORD_NOT_MATCH";
export const INVALID_HIT = "INVALID_HIT";

/**
 * The following errors will automatically get tested.
 */
export const ALL_ERRORS_LIST = [
  REQUIRED,
  NOT_VALID,
  MIN_VALUE,
  MIN_LENGTH,
  USER_INACTIVE,
  USER_ALREADY_EXISTS,
  CURRENT_PASSWORD_NOT_MATCH,
  INVALID_HIT
];